<template>
    <v-row no-gutters>
        <v-container>
            <template>
                <v-row justify="center">
                    <v-dialog v-model="dialog" persistent max-width="400">
                        <v-progress-linear v-if="isLoading" indeterminate color="indigo darken-2"></v-progress-linear>
                        <v-card>
                            <v-card-title class="text-h5">
                                Konfirmasi
                            </v-card-title>
                            <v-card-text style="min-height: 50px;">Apakah anda yakin?</v-card-text>
                            <v-card-actions class="justify-content-center">
                                <v-spacer></v-spacer>
                                <v-btn :disabled="isLoading" color="indigo darken-4" text @click="onCloseDialog(false)">
                                    Batal
                                </v-btn>
                                <v-btn :disabled="isLoading" color="indigo darken-4 white--text"
                                    @click="onCloseDialog(true)">
                                    Simpan
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <div class="p-3">
                    <v-card elevation="2" class="p-3">
                        <v-form ref="addRubric" v-model="addRubric" lazy-validation>
                            <h6 class="text-body-1 pb-5 indigo--text text--darken-4">Kelola FAQ<v-icon
                                    class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                            <v-row>
                                <v-col cols="12">
                                    <v-row>
                                        <v-data-table :headers="headers" :items="faqs" :items-per-page="5"
                                            class="elevation-0">
                                            <template v-slot:top>
                                                <v-toolbar flat>
                                                    <v-divider class="mx-4" inset vertical></v-divider>
                                                    <v-spacer></v-spacer>
                                                    <v-menu offset-y close-on-content-click>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn color="indigo darken-4 white--text" class="mb-2 ml-2"
                                                                @click="addComponent()">
                                                                <v-icon left>mdi-plus</v-icon>Tambah<v-divider class="px-2"
                                                                    vertical></v-divider>
                                                            </v-btn>
                                                        </template>

                                                    </v-menu>
                                                </v-toolbar>
                                            </template>
                                            <template v-slot:item.key="{ item }">
                                                <v-textarea flat rows="3" :auto-grow="true" :full-width="true"
                                                    v-model="item.key" :hide-details="true" :rules="$rules.required"
                                                    solo required placeholder="Pertanyaan"></v-textarea>

                                            </template>
                                            <template v-slot:item.value="{ item }">
                                                <v-textarea flat rows="3" :hide-details="true" :auto-grow="true" :full-width="true"
                                                    v-model="item.value" :rules="$rules.required" solo required
                                                    placeholder="Jawaban"></v-textarea>

                                            </template>
                                            <template v-slot:item.actions="{ item }">
                                                <v-chip class="ma-2" color="red darken-4" label text-color="white">
                                                    <v-icon color="dark" @click="onDeleteItem(item)">
                                                        mdi-minus
                                                    </v-icon>
                                                </v-chip>

                                            </template>
                                            <template v-slot:no-data>
                                                <br>
                                                Belum ada data<br>
                                                <v-btn class="m-4" color="gray" @click="getData()">
                                                    Mulai ulang
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <div class="d-flex justify-content-center mt-5">
                                <v-btn class="m-2" outlined color="primary" :to="{name: 'help-and-information-student'}">
                                    Kembali
                                </v-btn>
                                <v-btn class="m-2" color="primary" @click="dialog = true">
                                    Simpan
                                </v-btn>
                            </div>
                        </v-form>
                    </v-card>
                </div>
            </template>
        </v-container>
    </v-row>
</template>

<script>
import { serialize } from "object-to-formdata";
export default {
    data() {
        return {
            headers: [
                {
                    text: 'No.',
                    align: 'start',
                    sortable: false,
                    value: 'no',
                },
                { text: 'Question', value: 'key' },
                { text: 'Answer', value: 'value' },
                { text: 'Action', value: 'actions' },
            ],
            formFaq: {
                key: undefined,
                value: undefined
            },
            user: JSON.parse(localStorage.getItem("user")),
            faqs: [

            ],
            addRubric: true,
            dialog: false,
            isLoading: false,
            idRubrik: undefined
        }
    }, created() {
        this.getData();
        console.log(this.user);
    },
    methods: {
        getData() {
            this.isLoading = true;
            this.axios.get("/api/faqs/").then((res) => {
                this.faqs = res.data.map((el, i) => {
                    el.no = i + 1;
                    return el;
                });
                console.log(this.faqs);
            }).finally(() => this.isLoading = false);
        },
        onDeleteItem(row) {
            let editedIndex = this.faqs.indexOf(row)
            if (this.faqs.length == 1 && editedIndex == 0) {
                this.faqs.push({
                    nama: null,
                    faqs: null
                })
            }
            this.faqs.splice(editedIndex, 1)
        },
        addComponent() {
            this.faqs.push(
                {
                    nama: null,
                    bobot: null
                }
            )
        },
        buttonBackClick() {
            this.$router.push({ name: "manage-rubric.index" });
        },
        onCloseDialog(event) {
            if (event == true) {
                this.submit();
                this.dialog = false
            } else {
                this.dialog = false;
            }
        },
        submit() {
            let url = "/api/faqs";
            const valid = this.$refs.addRubric.validate();
            if (valid) {
                this.isLoading = true;
                const options = {
                    indices: false,
                    nullsAsUndefineds: true,
                    booleansAsIntegers: false,
                    allowEmptyArrays: false,
                    noFilesWithArrayNotation: false,
                    dotsForObjectNotation: false,
                };
                if (this.FORM_STATUS === "update") {
                    this.formRubric["_method"] = "put";
                    url = "/api/faqs/";
                }
                let formData = new FormData();
                formData = serialize(this.formRubric, options);
                if (this.faqs.length > 0)
                    this.faqs.forEach((el, i) => {
                        formData.append('faqs[' + i + '][prodi_id]', this.user.prodis[0].id);
                        formData.append('faqs[' + i + '][key]', el.key);
                        formData.append('faqs[' + i + '][value]', el.value);
                    });
                this.axios
                    .post(url, formData)
                    .then((res) => {
                        this.$emit("toast", "success", "Berhasil menyimpan data");
                        this.getData();
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.isLoading = false;

                    });
            } else {
                this.$emit("toast", "warning", "Masih ada field yang kosong");
            }
        },
    }
}
</script>